import moment from "moment/moment";
import html2canvas from "html2canvas"
import jsPDF from "jspdf"

// *Email Regex
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// *Password Regex
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_~=@#$>.<,[{}()!%\|'"`:;+*?&])[A-Za-z\d_~=@#$>.<,[{}()!%\|'"`:;+*?&]{8,}$/

// *Mobile Regex
// export const mobileRegex = /^(\+92)?(0)?3[0-9]{9}$/  //* Old Regex
export const mobileRegex = /^(\+92)[0-9]{10}$/

// *Business Mobile Regex
export const businessMobileRegex = /^\+[0-9]{7,15}$/

// *Manufacturer Type Id
export const ManufacturerTypeId = 2

// *Drop Shipper Type Id
export const DropShipperTypeId = 3

// *Supplier Type Id
export const SupplierTypeId = 4

// *Capitalize
export const Capitalize = (str) => {
  if (str === null || str === undefined || str === '') return ''
  const array = String(str).split(" ");

  for (var i = 0; i < array.length; i++) {
    array[i] = array[i].charAt(0).toUpperCase() + array[i].slice(1);
  }
  const capitalString = array.join(" ");
  return capitalString
}

// *For Date Format
export const getDateFormate = (date) => {
  if (!date) return
  const newDate = moment(date).format('YYYY-MM-DD')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
}

export const getDate = (date) => {
  if (!date) return
  const newDate = moment(date).format('DD-MM-YYYY')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
}

export const getDateTime = (date) => {
  if (!date) return
  const newDate = moment(date).format('DD-MMM-YYYY  h:mm A')
  return newDate
}

// *For Generate PDF
export const GeneratePDF = (content, filename) => {
  html2canvas(content, { scrollX: 0, scrollY: 0 }).then(canvas => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF();
    const pdfWidth = pdf.internal.pageSize.getWidth();
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, 0);
    pdf.save(`${filename}.pdf`);
  });
}

export function useLocalTime(dateStr) {
  if (dateStr) {
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetMilliseconds = offsetMinutes * 60 * 1000;

    const originalDate = new Date(dateStr);
    const accurateDate = new Date(originalDate.getTime() - offsetMilliseconds);

    return accurateDate;
  }
}

// *For Debounce
let debounceTimer;
export const Debounce = (func, delay = 1000) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(func, delay);
};

export const maskPhoneNumber = (phone) => {
  if (!phone) return "";
  const str = phone.toString();
  if (str.length < 7) return str;

  return str.slice(0, 5) + "****" + str.slice(-3);
}

export const maskEmail = (email) => {
  if (!email) return "";
  const [user, domain] = email.split("@");
  if (user.length <= 2) return `**@${domain}`;

  return `${user.substring(0, 2)}***${user.slice(-1)}@${domain}`;
}